// Guards against SecurityError thrown when localStorage is blocked by the browser
// (strict privacy mode, sandboxed webviews, certain Android Chrome builds, etc.).
// All callers should use this instead of accessing localStorage directly.
const safeStorage = {
  getItem(key) {
    try { return localStorage.getItem(key); } catch { return null; }
  },
  setItem(key, value) {
    try { localStorage.setItem(key, value); } catch { /* deliberately silent */ }
  },
  removeItem(key) {
    try { localStorage.removeItem(key); } catch { /* deliberately silent */ }
  }
};

export default safeStorage;
